
import { useEffect, useState } from 'react'
import './style.scss'
import { userStateData } from '../../data/userStateData'
import { useAppSelector } from '../../redux/hooks'
import LabeledInput from '../../components/labeledInput/LabeledInput'
import LabeledDropDown from '../../components/labeledDropDown/LabeledDropDown'
import { INSTRUCTOR_GENDERS, LANGUAGES } from '../../constants/searchConstants'
import { ImageUploadResponse } from '../../server/types'
import { API_URL } from '../../constants/pathConstants'
import { updateConnector } from '../../server/connector/updateConnector'
import CtaButton from '../../components/ctaButton/CtaButton'
import { useCookies } from 'react-cookie'
import { getCroppedImg, getRotatedImage, readFile } from '../../utils/Cropper'
import { Orientation, getOrientation } from 'get-orientation'
import Cropper from 'react-easy-crop'
// import LabeledSelectMenu from '../../components/labeledSelectMenu/LabeledSelectMenu'

function DashboardProfileContentArea() {
	const [userDataLoaded, setUserDataLoaded] = useState<boolean>(false)

	const dataLoadRequestFinished: boolean = useAppSelector(state => state.user.dataLoadRequestFinished)

	const [profilePicUrl, setProfilePicUrl] = useState<string | undefined>(undefined)
	const [yourName, setYourName] = useState<string | undefined>(undefined)
	const [email, setEmail] = useState<string | undefined>(undefined)
	const [address, setAddress] = useState<string | undefined>(undefined)
	const [country, setCountry] = useState<string | undefined>(undefined)
	const [phoneNumber, setPhoneNumber] = useState<string | undefined>(undefined)
	const [gender, setGender] = useState<string | undefined>(undefined)
	const [city, setCity] = useState<string | undefined>(undefined)
	const [language, setLanguage] = useState<string | undefined>(undefined)

	const [uploadingImage, setUploadingImage] = useState<boolean>(false)
	const [updatingUserData, setUpdatingUserData] = useState<boolean>(false)

	const [cookies, setCookie] = useCookies(['userData'])

	// Setup test values
	useEffect(() => {
		if (dataLoadRequestFinished === true) {
			updateUserValues()
			setUserDataLoaded(true)
		}
	}, [dataLoadRequestFinished])

	// Update the local user cookies to values match when browser is refreshed without loading from server
	const updateCookies = () => {
		setCookie("userData", userStateData.getUserData(), {
			path: "/"
		})
	}

	const updateUserValues = () => {
		setYourName(userStateData.getUsersName())
		setEmail(userStateData.getEmail())
		setAddress(userStateData.getAddress())
		setCountry(userStateData.getCountry())
		setPhoneNumber(userStateData.getPhoneNumber())
		setGender(userStateData.getGender())
		setCity(userStateData.getCity())
		setLanguage(userStateData.getLanguage())
		setProfilePicUrl(userStateData.getUserIconUrl())
	}

	const yourNameOnChange = (newValue: string) => {
		setYourName(newValue)
	}
	const emailOnChange = (newValue: string) => {
		setEmail(newValue)
	}
	const addressOnChange = (newValue: string) => {
		setAddress(newValue)
	}
	const countryOnChange = (newValue: string) => {
		setCountry(newValue)
	}
	const phoneNumberOnChange = (newValue: string) => {
		setPhoneNumber(newValue)
	}
	const genderOnChange = (newValue: string) => {
		setGender(newValue)
	}
	const cityOnChange = (newValue: string) => {
		setCity(newValue)
	}
	const languageOnChange = (newValue: string) => {
		setLanguage(newValue)
	}

	const setUserData = () => {
		userStateData.setName(yourName)
		userStateData.setEmail(email)
		userStateData.setAddress(address)
		userStateData.setCountry(country)
		userStateData.setPhoneNumber(phoneNumber)
		userStateData.setGender(gender)
		userStateData.setLanguage(language)
		userStateData.setCity(city)
	}

	const uploadFile = (file: File) => {
		console.log("Uploading file...")
		setUploadingImage(true)
		const API_ENDPOINT = `${API_URL}upload-image`
		const request = new XMLHttpRequest()
		const formData = new FormData()

		request.open("POST", API_ENDPOINT, true)
		request.onreadystatechange = () => {
			if (request.readyState === 4 && request.status === 200) {
				// console.log(request.responseText)
				const responseObj: ImageUploadResponse = JSON.parse(request.responseText)
				if (responseObj.error) {
					setUploadingImage(false)
				} else if (responseObj.fileName) {
					imageAdded(responseObj.fileName)
				}
			}
		}
		formData.append("file", file);
		request.send(formData);
	}

	const imageAdded = (fileName: string) => {
		setUploadingImage(false)
		// Called when new image upload is complete so image details can be updated
		setUpdatingUserData(true)

		if (updateConnector.requestInProgress) {
			console.log('[InstructorsProfile] - requestProfile() called while requestInProgress')
		} else {
			updateConnector.updateUserProfilePicsRequest(userStateData.getId(), fileName).then((successRequest) => {
				setUpdatingUserData(false)
				if (!successRequest) {
					console.log('WARNING - [DashboardChatContentArea] - requestProfile() failed')
				} else {
					userStateData.setProfilePics(fileName)
					updateUserValues()
					updateCookies()
					// window.location.replace(PAGE_URLS.DASHBOARD_CUSTOMER)
				}
			})
		}
	}

	const updateDataOnClick = () => {
		setUpdatingUserData(true)
		setUserData()

		if (updateConnector.requestInProgress) {
			console.log('[InstructorsProfile] - requestProfile() called while requestInProgress')
		} else {
			updateConnector.updateUserDataRequest(userStateData.getId()).then((successRequest) => {
				setUpdatingUserData(false)
				if (!successRequest) {
					console.log('WARNING - [DashboardChatContentArea] - requestProfile() failed')
				} else {
					updateUserValues()
					updateCookies()
					// window.location.replace(PAGE_URLS.DASHBOARD_CUSTOMER)
				}
			})
		}
	}

	// ====================================== IMAGE CROPPER ============================= 
	const uploadImage = (file: File) => {
		setUploadingImage(true)
		const API_ENDPOINT = `${API_URL}upload-image`
		const request = new XMLHttpRequest()
		const formData = new FormData()

		request.open("POST", API_ENDPOINT, true)
		request.onreadystatechange = () => {
			if (request.readyState === 4 && request.status === 200) {
				const responseObj: ImageUploadResponse = JSON.parse(request.responseText)
				if (responseObj.error) {
					setUploadingImage(false)
				} else if (responseObj.fileName) {
					imageAdded(responseObj.fileName)
				}
			}
		}
		formData.append("file", file);
		request.send(formData);
	}

	const [crop, setCrop] = useState({ x: 0, y: 0 })
	const [rotation, setRotation] = useState(0)
	const [zoom, setZoom] = useState(1)
	const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null)
	const [imageSrc, setImageSrc] = useState<any>(null)
	const onFileChange = async (e: any) => {
		if (e.target.files && e.target.files.length > 0) {
			const file = e.target.files[0]
			let imageDataUrl = await readFile(file)

			try {
				// apply rotation if needed
				const orientation = await getOrientation(file)
				let rotation: number = 0 // ORIENTATION_TO_ANGLE[orientation]
				if (orientation == Orientation.BOTTOM_RIGHT) {
					rotation = 180
				} else if (orientation == Orientation.RIGHT_TOP) {
					rotation = 90
				} else if (orientation == Orientation.LEFT_BOTTOM) {
					rotation = -90
				}
				imageDataUrl = await getRotatedImage(imageDataUrl, rotation)
			} catch (e) {
				console.warn('failed to detect the orientation')
			}

			setImageSrc(imageDataUrl)
		}
	}
	const onCropComplete = (croppedArea: any, croppedAreaPixels: any) => {
		setCroppedAreaPixels(croppedAreaPixels)
	}
	const showCroppedImage = async () => {
		try {
			const croppedImage = await getCroppedImg(
				imageSrc,
				croppedAreaPixels,
				rotation
			)
			uploadImage(croppedImage)
			setImageSrc(null)
		} catch (e) {
			console.error(e)
		}
	}

	return (
		<div className='dashboard-content-area-wrap'>
			{userDataLoaded &&
				<>
					<div className='dashboard-content-area-wide-card-wrap'>
						<div className='dashboard-profile-section-wrap'>
							{profilePicUrl &&
							<div className='dashboard-profile-profile-img-content'>
								<div className='dashboard-profile-profile-img-wrap'>
									<img 
										className='dashboard-profile-profile-img'
										src={profilePicUrl}
										alt='Profile'
									/>
									<label
										className='dashboard-profile-profile-img-upload-button'
									>
										<input
											type='file'
											onChange={(event) => {
												// if (event.target.files && event.target.files.length > 0) {
												// 	uploadFile(event.target.files[0])
												// }
												onFileChange(event)
											}}
											accept='image/*'
											disabled={uploadingImage || updatingUserData}
										/>
										<img
											src='/imgs/icons/dashboard/icon-edit.svg'
											alt='Change Profile'
										/>
									</label>
								</div>
							</div>
							}
						</div>
						<div className='dashboard-profile-section-wrap'>
							<LabeledInput
								label='Your Name'
								onChange={yourNameOnChange}
								value={yourName}
								disabled={uploadingImage || updatingUserData}
							/>
							<LabeledInput
								label='Email'
								onChange={emailOnChange}
								value={email}
								type='email'
								disabled={uploadingImage || updatingUserData}
							/>
							<LabeledInput
								label='Address'
								onChange={addressOnChange}
								value={address}
								disabled={uploadingImage || updatingUserData}
							/>
							<LabeledInput
								label='Country'
								onChange={countryOnChange}
								value={country}
								disabled={uploadingImage || updatingUserData}
							/>
						</div>
						<div className='dashboard-profile-section-wrap'>
							<LabeledInput
								label='Phone Number'
								onChange={phoneNumberOnChange}
								value={phoneNumber}
								disabled={uploadingImage || updatingUserData}
							/>
							<LabeledDropDown
								label='Gender'
								onChange={genderOnChange}
								value={gender}
								options={INSTRUCTOR_GENDERS}
								disabled={uploadingImage || updatingUserData}
							/>
							<LabeledInput
								label='City'
								onChange={cityOnChange}
								value={city}
								disabled={uploadingImage || updatingUserData}
							/>
							<LabeledDropDown
								label='Language'
								onChange={languageOnChange}
								value={language}
								options={LANGUAGES}
								disabled={uploadingImage || updatingUserData}
							/>
						</div>
					</div>
					{/* {valueChanged &&  */}
						<>
							<div className='update-button-wrap-spacer' />
							<div className='update-button-wrap'>
								<CtaButton
									label='Update'
									onClick={() => updateDataOnClick()}
									size='medium'
									disabled={uploadingImage || updatingUserData}
								/>
							</div>
						</>
					{/* } */}
					{/* <div className='update-button-wrap'>
						<CtaButton
							label='Update'
							onClick={() => updateDataOnClick()}
							size='medium'
							disabled={uploadingImage || updatingUserData}
						/>
					</div> */}
				</>
			}
			{
			// showCropper &&
			imageSrc &&
				<div className='cropper-modal'>
					<div className='cropper-wrapper'>
						<Cropper
							image={imageSrc}
							crop={crop}
							rotation={rotation}
							zoom={zoom}
							aspect={1}
							onCropChange={setCrop}
							onRotationChange={setRotation}
							onCropComplete={onCropComplete}
							onZoomChange={setZoom}
						/>
					</div>
					<div className='cropped-button-wrap'>
						<CtaButton
							label='Cancel'
							size='medium'
							onClick={() => {
								setImageSrc(null)
							}}
						/>
						<CtaButton
							label='Crop Image'
							size='medium'
							onClick={() => {
								showCroppedImage()
							}}
						/>
					</div>
				</div>
			}
		</div>
	)
}

export default DashboardProfileContentArea
